<template id="app">
    <v-card class="overflow-hidden v-card v-sheet theme--light">
     <!-- Alert message -->
     <div>
       <v-alert :type="alert_type" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
     </div>
     <!-- Header-->
       <HeaderComponent 
          :headerTitle="headerText" 
          :router-link="getRouterLink()"
          :router-link-text="action_title" 
          :return-condition="true" 
          :component-name="track_trip_id">
         </HeaderComponent>
 
     <!-- Popup UI -->
 <!-- logistics Fta Request ID -->
 <v-row justify="center">
       <v-dialog v-model="logisticsFtaRequestIDpopup" persistent max-width="759px">
         <v-card class="v-card-100">
           <v-card class="v-card-100">
             <v-card-title >
               <span style="font-size: 24px; padding-left: 8px;">Logistics Fta Request ID: {{ select_id }}</span><br>
               <v-spacer></v-spacer>
               <v-btn icon @click="logisticsFtaRequestIDpopup = false">
                 <v-icon>mdi-close</v-icon>
               </v-btn>
             </v-card-title>
           </v-card>
           <v-card-text class="p-0 overflow-auto" style="height: 600px;">
             <v-container>
                 <v-col cols="6" sm="6" md="6" class="pl-3">
                   <span style="font-weight: 600; font-size: 18px; color:#2D2D2D;">Replacement Item</span>
                 </v-col>
                 <v-row class="pl-3">
                     <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600; color:#0357D0;">ORRD Number</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600;">RP1123</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600; color:#0357D0;">ORRD Type</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600;">Replacement Order</span>
                 </v-col>
                 </v-row>
                 <v-row class="pl-3">
                     <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600; color:#0357D0;">Item Count</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600;">2</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600; color:#0357D0;">ORD Number</span>
                 </v-col>
                 <v-col cols="6" sm="6" md="3">
                   <span style="font-weight: 600;">RP12345</span>
                 </v-col>
                 </v-row>
                 <v-data-table
                     :dense="true"
                     :search="search"
                     v-model="selected"
                     disable-pagination
                     :hide-default-footer="true"
                     :headers="item_headers"
                     :items="details_data"
                     fixed-header
                     height="100%" 
                     :loading="loading"
                     loading-text="Loading Data... Please wait"
                     style="line-height: 50px;"
                     ></v-data-table>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Pickup Location Details</span>
                 </v-col>
                 <v-col cols="8">
                   -
                   <!-- {{ logistics_FTA_Request_ID.article_id ? logistics_FTA_Request_ID.article_id : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Pickup Location Contact Details</span>
                 </v-col>
                 <v-col cols="8">
                     Naveen T  +917708650382
                   <!-- {{ logistics_FTA_Request_ID.article_description ? logistics_FTA_Request_ID.article_description : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Vehicle Number</span>
                 </v-col>
                 <v-col cols="8">
                     KA 53 8796
                   <!-- {{ logistics_FTA_Request_ID.category ? logistics_FTA_Request_ID.category : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Vehicle Type</span>
                 </v-col>
                 <v-col cols="8">
                     Light duty Truck
                   <!-- {{ logistics_FTA_Request_ID.client_name ? logistics_FTA_Request_ID.client_name : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Logistic Executive</span>
                 </v-col>
                 <v-col cols="8">
                     karan
                   <!-- {{ logistics_FTA_Request_ID.client_contact_number ? logistics_FTA_Request_ID.client_contact_number : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Logistic Executive Contact no</span>
                 </v-col>
                 <v-col cols="8">
                     +919851789021
                   <!-- {{ logistics_FTA_Request_ID.testing_location ? logistics_FTA_Request_ID.testing_location : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Logistic Assistant</span>
                 </v-col>
                 <v-col cols="8">
                     sanju
                   <!-- {{ logistics_FTA_Request_ID.serial_number_1 ? logistics_FTA_Request_ID.serial_number_1 : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Logistic Assistant Contact no</span>
                 </v-col>
                 <v-col cols="8">
                     +919951789077
                   <!-- {{ logistics_FTA_Request_ID.serial_number_2 ? logistics_FTA_Request_ID.serial_number_2 : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Activity Location Latitude</span>
                 </v-col>
                 <v-col cols="8">
                     38.8951
                   <!-- {{ logistics_FTA_Request_ID.serial_number_2 ? logistics_FTA_Request_ID.serial_number_2 : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Activity Location Longitude</span>
                 </v-col>
                 <v-col cols="8">
                     -77.0364
                   <!-- {{ logistics_FTA_Request_ID.serial_number_2 ? logistics_FTA_Request_ID.serial_number_2 : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Tagged Location Latitude</span>
                 </v-col>
                 <v-col cols="8">
                     38.8955
                   <!-- {{ logistics_FTA_Request_ID.taggedLocationLatitude ? logistics_FTA_Request_ID.taggedLocationLatitude : 'N/A' }} -->
                 </v-col>
               </v-row>
               <v-row class="pl-3">
                 <v-col cols="4">
                   <span style="font-weight: 500;">Tagged Location Longitude</span>
                 </v-col>
                 <v-col cols="8">
                     -77.0368
                   <!-- {{ logistics_FTA_Request_ID.serial_number_2 ? logistics_FTA_Request_ID.serial_number_2 : 'N/A' }} -->
                 </v-col>
               </v-row>
             </v-container>
           </v-card-text>
         </v-card>
       </v-dialog>
     </v-row>
 
         <!-- Data Table -->
         <v-layout column>
         <v-flex md6 style="overflow: auto">
             <v-data-table
             :dense="true"
             v-model="selected"
             show-select
             disable-pagination
             :hide-default-footer="true"
             :headers="headers"
             :items="table_data"
             :loading="loading"
             fixed-header
             height="100%"
             loading-text="Loading Data... Please wait"
             class="elevation-1 dataTable"
             >
             <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }">
                 <span v-if="header.value !== 'request_id'">
                 <span v-if="item[header.value] !== null && item[header.value] !== ''">
                     <span v-if="header.value === 'actual_pickup_date'">
                     {{ item[header.value] }}
                     </span>
                     <span v-else>
                     {{ item[header.value] }}
                     </span>
                 </span>
                 <span v-else>
                     <span>-</span>
                 </span>
                 </span>
             </template>
             <template #[`item.logistics_FTA_Request_ID`]="{ item }">
                 <a v-if="item.logistics_FTA_Request_ID" @click="logisticsFtaRequestID(item)" style="color: #1976d2; cursor: pointer;">
                 <span>
                     <u>{{ item.logistics_FTA_Request_ID }}</u>
                 </span>
                 </a>
             </template>
             </v-data-table>
         </v-flex>
         </v-layout>
     <div>
       <v-row class="ml-2 pb-0">
         <span class="PaddingItemPerPage d-flex mt-3">
           <label style="margin-top: -2px;">Rows Per Page</label>
           <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
           outlined style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
         </span>
 
         <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
           v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
         <v-spacer></v-spacer>
         <div class="d-flex">
           <span :class="this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
             - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
           <span class="PaddingItemPerPage mr-3" :style="totalPages>7 ? 'min-width: 380px' : 'auto'">
             <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
             @update:modelValue="handlePageChange" circle></v-pagination>
           </span>
         </div>
       </v-row>
     </div>
    </v-card>
 </template>
 <script>
 import HeaderComponent from "@/components/commoncomponents/HeaderComponent.vue";
 export default {
     data(){
         return {
             headerText: "FTA",
             alert : false,
             alert_type : "success",
             alert_message : '',
             loading : false,
             action_title: '',
             track_trip_id:'',
             select_id:'',
             search:'',
             logisticsFtaRequestIDpopup: false,
             pageSize: 100,
             pageSizes: [100, 200, 500],
             action_tab:'',
             totalCount: '',
             selected : [],
             page: 1,
             totalPages: 1,
             table_data: [
                 {
                     trip_creation_date: '2024-09-01',
                     logistics_FTA_Request_ID: 'RA12345',
                     Trip_Sequence: '1',
                     activity_Location: 'Warehouse A',
                     city: 'bangalore',
                     state: 'karnataka',
                     pinCode: '10001',
                     activity_Date_Time: '2024-09-01 10:00 AM'
                 },
                 {
                     trip_creation_date: '2024-09-02',
                     logistics_FTA_Request_ID: 'RAA12346',
                     Trip_Sequence: '2',
                     activity_Location: 'Warehouse B',
                     city: 'bangalore',
                     state: 'karnataka',
                     pinCode: '90001',
                     activity_Date_Time: '2024-09-02 02:30 PM'
                 },
                 {
                     trip_creation_date: '2024-09-03',
                     logistics_FTA_Request_ID: 'RA12347',
                     Trip_Sequence: '3',
                     activity_Location: 'Warehouse C',
                     city: 'bangaolre',
                     state: 'karnataka',
                     pinCode: '60601',
                     activity_Date_Time: '2024-09-03 11:45 AM'
                 }
             ],
             details_data: [
                 {
                     article_ID: 'ART12345',
                     article_Description: 'Laptop',
                     weight: '2.5 kg',
                     volumetric_Weight: '3.0 kg'
                 },
                 {
                     article_ID: 'ART12346',
                     article_Description: 'Smartphone',
                     weight: '0.2 kg',
                     volumetric_Weight: '0.25 kg'
                 },
             ],
             headers:[
                 { text : 'Trip Assignment  Date', value : 'trip_creation_date'},
                 { text : 'Logistics FTA Request ID', value : 'logistics_FTA_Request_ID'},
                 { text : 'Trip Sequence', value : 'Trip_Sequence'},
                 { text : 'Activity Location', value : 'activity_Location'},
                 { text : 'City', value : 'city'},
                 { text : 'State', value : 'state'},
                 { text : 'PinCode', value : 'pinCode'},
                 { text : 'Activity Date & Time', value : 'activity_Date_Time'},
             ],
             item_headers:[
               { text: "Article ID", align: "start", value:"article_ID"},
               { text: "Article Description", value: "article_Description" },
               { text: "Weight", align: "start", value:"weight"},
               { text: "Volumetric Weight", value: "volumetric_Weight" },
             ],
         }
     },
     async created() {
       this.action_tab = this.$store.state.action;
       this.action_title = 'Track Trips'
       this.track_trip_id = this.$store.state.lotIds;
     },
     components :{
       HeaderComponent
     },
     methods: {
         showAlert(alert_type, alert_message) {
         this.alert = true;
         this.alert_type = alert_type;
         this.alert_message = alert_message;
         this.scrollToTop();
         this.alertTimeOut();
       },
       alertTimeOut() {
         setTimeout(() => {
             this.alert = false;
         }, 3000);
       },
       scrollToTop() {
         window.scrollTo({
           top: 0,
           behavior: 'smooth',
         });
       },
       getRouterLink() {
         if(this.action_tab === 'Track Trips'){
             this.$store.commit("setActiveTab", {
                 active_tab:'third_tab'
                 });
             return { name: "ftaReverseLogistics" };
         }
       },
       logisticsFtaRequestID(item){
         this.logisticsFtaRequestIDpopup = true;
         this.select_id = item.logistics_FTA_Request_ID;
       },
       handlePageChange(value) {
             this.page = value;
             this.loadData();
       },
       handlePageSizeChange(size) {
             this.pageSize = size;
             this.page = 1
             this.loadData();
       },
     }
 }
 </script>
 <style scoped>
 .item-selected {
   margin-top: 23px;
   position: absolute;
   left: 41%;
 }
 @media (max-height: 1104px) {
   .PaddingItemPerPage {
     padding: 8px !important;
   }
 }
 
 @media (min-height: 1126px) {
   .PaddingItemPerPage {
     padding: 24px !important;
   }
 }
 .dataTable {
   height: calc(var(--vh, 1vh) * 100 - 165px) !important;
 }
 </style>